import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import { Zap, Mail, Lock, User, ArrowRight } from 'lucide-react';

export default function Signup() {
  const { signup } = useAuth();
  const [form, setForm] = useState({ name: '', email: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password.length < 8) { toast.error('Password must be at least 8 characters.'); return; }
    setLoading(true);
    try {
      await signup(form.name, form.email, form.password);
      toast.success('Account created! Welcome to ColdCraft AI.');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Signup failed.');
    } finally { setLoading(false); }
  };

  const fields = [
    { key:'name', label:'Full Name', type:'text', placeholder:'Your name', Icon:User },
    { key:'email', label:'Email', type:'email', placeholder:'you@company.com', Icon:Mail },
    { key:'password', label:'Password', type:'password', placeholder:'Min. 8 characters', Icon:Lock },
  ];

  return (
    <div style={{ minHeight:'100vh', background:'var(--bg)', display:'flex', alignItems:'center', justifyContent:'center', padding:'2rem', backgroundImage:'radial-gradient(ellipse at 50% 0%, rgba(108,71,255,0.12) 0%, transparent 60%)' }}>
      <div style={{ width:'100%', maxWidth:400 }}>
        <div style={{ textAlign:'center', marginBottom:36 }}>
          <div style={{ width:48, height:48, background:'linear-gradient(135deg,#6c47ff,#4f46e5)', borderRadius:12, display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px', boxShadow:'0 0 30px rgba(108,71,255,.3)' }}>
            <Zap size={22} color="white" fill="white" />
          </div>
          <h1 style={{ fontSize:24, fontWeight:800, letterSpacing:'-.03em' }}>Create your account</h1>
          <p style={{ color:'var(--muted)', marginTop:6, fontSize:14 }}>Start sending smarter cold emails</p>
        </div>

        <div className="card" style={{ padding:28 }}>
          <form onSubmit={handleSubmit} style={{ display:'flex', flexDirection:'column', gap:16 }}>
            {fields.map(({ key, label, type, placeholder, Icon }) => (
              <div key={key}>
                <label style={{ display:'block', fontSize:12, fontWeight:600, marginBottom:6, color:'var(--muted)' }}>{label}</label>
                <div style={{ position:'relative' }}>
                  <Icon size={14} style={{ position:'absolute', left:12, top:'50%', transform:'translateY(-50%)', color:'var(--muted)' }} />
                  <input className="input" type={type} placeholder={placeholder} value={form[key]}
                    onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))}
                    style={{ paddingLeft:34 }} required />
                </div>
              </div>
            ))}
            <button type="submit" className="btn btn-primary" disabled={loading} style={{ width:'100%', justifyContent:'center', padding:'11px' }}>
              {loading ? 'Creating...' : <><span>Create account</span><ArrowRight size={15} /></>}
            </button>
          </form>
        </div>

        <p style={{ textAlign:'center', marginTop:20, fontSize:14, color:'var(--muted)' }}>
          Already have an account? <Link to="/login" style={{ color:'var(--accent2)', fontWeight:600, textDecoration:'none' }}>Sign in</Link>
        </p>
      </div>
    </div>
  );
}